export default {
    name: 'ContextUser',
    properties: {
        uuid: { required: true },
        groups: { type: 'array', name: 'groups' },
        custom: {},
    },
};
